import { render, staticRenderFns } from "./customizeModal.vue?vue&type=template&id=3ab75268"
import script from "./customizeModal.vue?vue&type=script&lang=js"
export * from "./customizeModal.vue?vue&type=script&lang=js"
import style0 from "./customizeModal.vue?vue&type=style&index=0&id=3ab75268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports